<template>
  <div class="add-to-cart-container">
    <button disabled v-if="isEtaAtRisk" aria-label="Shop Similar In Stock" class="out-of-stock-button">
      <slot>COMING BACK SOON</slot>
    </button>
    <form v-else class="add-to-cart-form" @submit.prevent.stop="onAddToCart(products)">
      <div v-if="showLoader && isAddingCart" class="button add-to-cart-loader" :class="[...buttonClasses, { small: isSmallVariant }]">
        <slot name="loader">
          <span class="loader tiny"></span>
        </slot>
      </div>
      <template v-else>
        <div class="qty-add">
          <QuantitySelector
            v-if="products.length == 1 && showQuantitySelector"
            :packagedItemQuantity="products[0].quantity"
            @onQuantityChange="setQuantity"
          />
          <button
            ref="addToCartButton"
            class="add-cart-button"
            name="addToCart"
            type="submit"
            aria-label="Add to cart"
            :class="[...buttonClasses, { small: isSmallVariant }]"
          >
            <slot>Add To Cart</slot>
          </button>
        </div>
      </template>
    </form>
  </div>
</template>

<script>
import useAddToCart from '@/compositions/useAddToCart.js';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import useCommon from '@/compositions/useCommon';
import QuantitySelector from './QuantitySelector.vue';

export default {
  components: { QuantitySelector },
  name: 'AddToCartButton',
  props: {
    scrollFirst: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      required: true,
    },
    animate: {
      type: Boolean,
      default: false,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
    buttonClasses: {
      type: Array,
      default: () => ['filled', 'coral'],
    },
    isEtaAtRisk: {
      type: Boolean,
      default: false,
    },
    showQuantitySelector: {
      type: Boolean,
      default: false,
    },
    isSmallVariant: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    const router = useRouter();
    const { notifyCartItemsAddedAction } = useCommon();
    const { addCartProcess, isAddingCart } = useAddToCart();
    const addToCartButton = ref(null);
    const quantity = ref(props.products[0].quantity);

    async function onAddToCart(products) {
      context.emit('beforeAdded', products);

      if (products.length === 1 && props.showQuantitySelector) {
        products[0].quantity = quantity.value;
      }

      await addCartProcess({
        products,
        buttonToAnimate: props.animate && addToCartButton.value,
        scrollFirst: props.scrollFirst,
      });

      if (router.currentRoute.value.path !== '/cart') {
        notifyCartItemsAddedAction();
      }
      context.emit('added', products);
    }

    function setQuantity(qty) {
      quantity.value = qty;
    }

    return {
      isAddingCart,
      onAddToCart,
      addToCartButton,
      setQuantity,
      quantity,
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.add-to-cart-container {
  .add-to-cart-form {
    display: initial;

    .add-to-cart-loader.small {
      padding: 0px !important;
      min-height: 24px !important;
      min-width: 49px;
      display: flex;
      justify-content: center;
      align-items: center;
      .loader {
        height: 12px;
        width: 12px;
      }
    }

    .add-cart-button {
      &.small {
        margin: 0px;
        padding: 4px 10px !important;
        height: 24px !important;
      }

      white-space: nowrap;
      flex-grow: 2;
    }
  }
  .out-of-stock-button {
    background: var(--grey-light);
    width: 100%;
    white-space: nowrap;
    border: 1px solid var(--grey-light);
    &:hover {
      background: var(--grey-light) !important;
      border: 1px solid var(--grey-light) !important;
    }
  }
  .qty-add {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: $tablet-breakpoint) {
      justify-content: start;
    }
  }
}
</style>
